interface PeopleWithCheckmarkAndMessageBubbleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleWithCheckmarkAndMessageBubbleSVG = ({
  color,
  style,
}: PeopleWithCheckmarkAndMessageBubbleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46573)">
      <path
        d="M5.2002 35.6649H18.337"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.2002 40.0209H18.337"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.2002 44.377H13.9581"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.337 8.43981C18.337 11.4455 15.8848 13.8848 12.8633 13.8848C9.84186 13.8848 7.38965 11.4455 7.38965 8.43981V6.2618C7.38965 3.25614 9.84186 0.816772 12.8633 0.816772C15.8848 0.816772 18.337 3.25614 18.337 6.2618V8.43981Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M0.821289 23.6859C0.821289 20.6802 3.2735 18.2408 6.29497 18.2408H19.4318C22.4533 18.2408 24.9055 20.6802 24.9055 23.6859"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.6105 36.7539C44.6105 39.7596 42.1582 42.1989 39.1368 42.1989C36.1153 42.1989 33.6631 39.7596 33.6631 36.7539V34.5759C33.6631 31.5702 36.1153 29.1309 39.1368 29.1309C42.1582 29.1309 44.6105 31.5702 44.6105 34.5759V36.7539Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.0947 52C27.0947 48.9944 29.5469 46.555 32.5684 46.555H45.7053C48.7267 46.555 51.1789 48.9944 51.1789 52"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M31.4737 0.816772C30.2695 0.816772 29.2843 1.79688 29.2843 2.99478V8.43981L23.6792 11.6959L29.2843 14.9738V20.4189C29.2843 21.6168 30.2695 22.5969 31.4737 22.5969H48.9895C50.1937 22.5969 51.179 21.6168 51.179 20.4189V2.99478C51.179 1.79688 50.1937 0.816772 48.9895 0.816772H31.4737Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.5266 29.1309C21.7308 29.1309 22.716 30.111 22.716 31.3089V36.7539L28.3211 40.01L22.716 43.2879V48.733C22.716 49.9309 21.7308 50.911 20.5266 50.911H3.01076C1.80655 50.911 0.821289 49.9309 0.821289 48.733V31.3089C0.821289 30.111 1.80655 29.1309 3.01076 29.1309H20.5266Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.7578 10.6723L39.1368 14.9738L45.8256 8.32001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46573">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PeopleWithCheckmarkAndMessageBubbleSVG;
